import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";

import { TranslateModule } from "@ngx-translate/core";
import { NgbModule, NgbTooltipModule } from "@ng-bootstrap/ng-bootstrap";
import { NgSelectModule } from "@ng-select/ng-select";
import { NgScrollbarModule } from 'ngx-scrollbar';
import { BlockUIModule } from "ng-block-ui";
import { MarkdownModule } from 'ngx-markdown';
import { PdfViewerModule } from 'ng2-pdf-viewer';

import { CoreCommonModule } from "@core/common.module";
import { CorePipesModule } from "@core/pipes/pipes.module";

import { IconsModule } from "app/components/icons";

import { ChatContentComponent } from "./chat-content/chat-content.component";
import { ChatFloatingButtonComponent } from "./chat-floating-button/chat-floating-button.component";
import { ChatQuoteModalComponent } from "./chat-quote-modal/chat-quote-modal.component";
import { ChatSidebarComponent } from "./chat-sidebar/chat-sidebar.component";
import { ChatDockComponent } from "./chat-dock/chat-dock.component";
import { ChatFilePreviewModalComponent } from "./chat-file-preview-modal/chat-file-preview-modal.component";
import { ChatAdaptiveCardComponent } from "./chat-adaptive-card/chat-adaptive-card.component";
import { ChatHistoryComponent } from "./chat-history/chat-history.component";

import 'prismjs';
import 'prismjs/components/prism-typescript.min.js';
import 'prismjs/plugins/line-numbers/prism-line-numbers.js';
import 'prismjs/plugins/line-highlight/prism-line-highlight.js';
import { RepositoryService } from "@repositories/services";

@NgModule({
  declarations: [
    ChatContentComponent,
    ChatFloatingButtonComponent,
    ChatQuoteModalComponent,
    ChatSidebarComponent,
    ChatDockComponent,
    ChatFilePreviewModalComponent,
    ChatHistoryComponent,
    ChatAdaptiveCardComponent
  ],
  imports: [
    CommonModule,
    CoreCommonModule,
    FormsModule,
    TranslateModule,
    CorePipesModule,
    NgbTooltipModule,
    NgbModule,
    NgScrollbarModule,
    BlockUIModule.forRoot(),
    MarkdownModule.forRoot(),
    NgSelectModule,
    PdfViewerModule,
    IconsModule
  ],
  providers: [RepositoryService],
  exports: [ChatContentComponent, ChatFloatingButtonComponent, ChatSidebarComponent, ChatDockComponent, ChatHistoryComponent],
})
export class ChatAIModule {}
